<!--
  首页 列表页 详情页 专题页 活动slot
-->
<template>
  <div class="ActSlot">
    <ActTwelveFloat />
<!--    <ActTwelveBar />-->
<!--    <ActNewUserCoupon />-->
  </div>
</template>

<script>
import ActTwelveFloat from "@/components/_Privately/Act/Act202312/ActTwelveFloat";
import ActTwelveBar from "@/components/_Privately/Act/Act202312/ActTwelveBar";
// const ActNewUserCoupon = () => import("@/components/_Privately/Act/ActNewUserCoupon/new-user-coupon.vue");

export default {
  name: "ActSlot",
  components:{
    ActTwelveFloat,
    ActTwelveBar,
    // ActNewUserCoupon
  }
}
</script>

<style scoped>

</style>
